import { ActionTree } from 'vuex';
import { AxiosResponse } from 'axios';
import HttpService from '@/plugins/http-service';
import IRootState from '@/store/types/IRootState';
import HomeState from './types/IHomeState';
import IHomeMeta from './types/IHomeMeta';
import { IHomeSlider } from './types/IHomeSlider';
import { IHomeStatistics } from './types/IHomeStatistics';
import { IHomeCovid19 } from './types/IHomeCovid19';

const actions: ActionTree<HomeState, IRootState> = {
  async load(context) {
    try {
      const { data: {
        meta,
        slider,
        statistics,
        covid19,
      } }: AxiosResponse<{
        meta: IHomeMeta,
        slider: IHomeSlider,
        statistics: IHomeStatistics,
        covid19: IHomeCovid19,
      }> = await HttpService.get(`/page/home.json`);

      context.commit('setMeta', meta);
      context.commit('setSlider', slider);
      context.commit('setStatistics', statistics);
      context.commit('setCovid19', covid19);

      return { meta, slider, statistics };
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

export default actions;
